import {UPDATE_STAGING_BASIC} from './constants';
import {makeActionCreator} from '../../../utils/actionsUtils';

export const updateStagingBasic = makeActionCreator(UPDATE_STAGING_BASIC, 'credentials');



// WEBPACK FOOTER //
// ./src/services/authentication/staging/actions.js